<template>
  <div class="vx-row">
    <div class="vx-col w-full flex flex-col">
      <vs-button
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-plus"
        class="mb-4 self-end"
        size="small"
        @click="$router.push({name: 'laporan-skp-buat'})"
      >Buat Laporan SKP</vs-button>
      <vs-card>
        <!-- <global-header></global-header>
        <global-wrapper-list
          :loading="$apollo.queries.templateSurat.loading"
          :loadingType="'TwoLine'"
          :loadingList="5"
          :empty="templateSurat.length <= 0"
          :error="error"
          :btnShowMore="btnShowMore"
        >
          <div class="flex flex-col">
            <vs-table :data="templateSurat">
              <template slot="thead">
                <vs-th>No.</vs-th>
                <vs-th>Nama</vs-th>
                <vs-th>Kategori Surat</vs-th>
                <vs-th>Keterangan</vs-th>
                <vs-th>Action</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
                  <vs-td :data="indextr">{{ indextr }}</vs-td>
                  <vs-td :data="tr.nama">{{ tr.nama }}</vs-td>
                  <vs-td :data="tr.kategori_surat.nama">{{ tr.kategori_surat.nama }}</vs-td>
                  <vs-td :data="tr.keterangan">{{ tr.keterangan }}</vs-td>
                  <vs-td>
                    <div class="vx-row">
                      <vs-button
                        @click="$router.push({name: 'template-surat-detail', params: {uuid: tr.uuid }})"
                        color="primary"
                        size="small"
                        class="m-1"
                        type="border"
                        icon-pack="feather"
                        icon="icon-eye"
                      >Detail</vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </global-wrapper-list> -->
      </vs-card>
    </div>
  </div>
</template>

<script>
import { digofHttp as axios } from "@/axios";

export default {
  data() {
    return {
      notifikasi: {
        data: [],
        paginatorInfo: {
          lastPage : 1,
          currentPage: 1
        }
      },
      error: false,
      paginationPage: 1,
      filterSearch: '',
      filterPengguna: {value : null, label : 'Semua Pegawai'},
      listPengguna: [{value : null, label : 'Semua Pegawai'}],
      isFilter: false
    };
  },
  methods : {
    downloadSkp(){
      let data = {
        pengguna_id : this.$sanctum.getUser().id
      }
      
      axios({
        url: "laporan-skp/download",
        method: "post",
        data: data
      })
      .then(response => {
        console.log(response);
        this.$vs.notify({
          title: "Sukses",
          text: "Berhasil download skp.",
          color: "success",
          position: "top-right"
        });
      }).catch(e => {
        console.error(e);
        this.$vs.notify({
          title: "Gagal",
          text: "Terjadi kesalahan, silahkan hubungi tim IT.",
          color: "danger",
          position: "top-right"
        });
      });
    }
  },
};
</script>